import React, { Component} from 'react';
import { translate } from 'react-i18next';
import {Typeahead} from 'react-bootstrap-typeahead';
import swal from 'sweetalert';
import { rejectReasons, functionalCriterial,clinicHistoryValuesOffer,donationNotesByOffer } from '../../../libs/services';
import { useState } from 'react';
import { Button } from 'react-bootstrap/lib/InputGroup';
import moment from 'moment';
const {htmlToText} = require('html-to-text');
class RejectionReason extends Component{
    
    constructor(props){
        super(props);
        this.keyUpRejectionDay = this.keyUpRejectionDay.bind(this);
        this.showValoration = this.showValoration.bind(this);

        var aux_date = new Date();
        this.state={
            don_abr_rech: {},
			rejection_reasons: [],
            DON_EDIT_REJECT_DAYS: false,
			donation_status: '',
            show_valoration: false,
			indiceRejection: -1,
            date: aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2)
        }
    }
    async componentWillMount(){
        var response = await functionalCriterial('don_abr_rech');
		if(response !== undefined){
			this.setState({
				don_abr_rech: response
			});
		}
		
        response = await functionalCriterial('DON_EDIT_REJECT_DAYS');
		if(response !== undefined){
			if (response.value === "NO") { 
				this.setState({
					DON_EDIT_REJECT_DAYS: true
				});
			} else {
				this.setState({
					DON_EDIT_REJECT_DAYS: false
				});
			}
		}
    }

    async componentDidMount(){
        const response = await rejectReasons('actives');

		if(response !== undefined){
            response.forEach((res)=>{
                res.values = res.name
            });

			this.setState({rejection_reasons:response});

            if (this.props.state.rejection_reasons_id !== null && this.props.state.rejection_reasons_id !== "") {
                for(var i = 0; i < response.length; i++){
                    if(parseInt(this.props.state.rejection_reasons_id,10) === response[i].id){
                        this.setState({
                            donation_status: response[i].rejection_days === 0 || response[i].rejection_days === null 
                                ? 'REJECT'
                                : response[i].rejection_days > 0 
                                    ? 'DIFERIDO' 
                                    : null,
                            indiceRejection: i
                        });
                    }
                }
            }
        }

        if (this.props.state.rejection_reasons_id !== null && this.props.state.rejection_reasons_id !== "") {
            this.setState({
                show_valoration: true
            });
        }

        if (this.props.state.rejections_days !== null && this.props.state.rejections_days !== "" && this.props.state.rejection_date !== "") {
            var days = Math.round(this.props.state.rejections_days);
            var new_date = this.addDays(this.props.state.rejection_date,days);

            this.setState({ 
                date: new_date.getFullYear()+'-'+("0" + (new_date.getMonth() + 1)).slice(-2)+'-'+("0" + new_date.getDate()).slice(-2),
            });
        }
    }
    
    handleTypeAheadChange = name => values => {
        if(values.length > 0){
        	var index = this.state.rejection_reasons.findIndex(obj => obj.id === values[0].id);
            const status = values[0].rejection_days === 0 || values[0].rejection_days === null 
                ? 'REJECT'
        		: values[0].rejection_days > 0 
                    ? 'DIFERIDO' 
                    : null;

        	const stateUpdtes = {
        		rejection_reasons_id: values[0].id,
        		status: status,
        		rejections_days: values[0].rejection_days,
        		rejection_description: values[0].name,
        	};

            this.props.updateState(stateUpdtes);

            this.setState({
                donation_status: status,
                indiceRejection: index
            });
            
        	var days = Math.round(values[0].rejection_days);
			var new_date = this.addDays(new Date(),days);
			this.setState({ 
				date: new_date.getFullYear()+'-'+("0" + (new_date.getMonth() + 1)).slice(-2)+'-'+("0" + new_date.getDate()).slice(-2)
			});
        }
 	}

    handleChangeInput = (event, index, value) => {
	    const stateUpdtes ={
	        [event.target.name]: event.target.value
	    };

	    this.props.updateState(stateUpdtes);

	    if(event.target.id !== null){
			var control = document.getElementById(event.target.id);

			if(event.target.value !== ""){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}else{
				control.classList.add('error');
			}
		}
	}

    keyUpRejectionDay(event){
    	var days = Math.round(this.state[event.target.name]);
		var new_date = this.addDays(new Date(),days);
                
        this.props.updateState({
            rejections_days: days
        });

		this.setState({ 
			date: new_date.getFullYear()+'-'+("0" + (new_date.getMonth() + 1)).slice(-2)+'-'+("0" + new_date.getDate()).slice(-2)
		});
	}

    addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        
        return result;
    }

    showValoration(e) {
        const stateUpdtes ={
            rejection_reasons_id: "",
        	status: "",
        	rejections_days: "",
        	rejection_description: "",
        };

        if (e.target.checked) {
            stateUpdtes.status = "NO_APTO";
        }

        this.props.updateState(stateUpdtes);
        
        this.setState({show_valoration: e.target.checked})
    }

    render(){
        const { t } = this.props
        
        return(
            <>
                <legend>{t('content.modal_hc.conclusion')}</legend>
                <div className="col-xs-12 form-group conclusion">
                    <div className="col-xs-12 col-md-2" style={{ padding: "2px 2px 2px 8px" }}>
                        <div className="col-xs-12 col-md-12" style={{ padding: "2px 2px 2px 8px" }}>
                            <span>Valorar </span>
                            <input
                                type="checkbox"
                                checked={this.state.show_valoration}
                                onChange={(e) => this.showValoration(e)}
                            />
                        </div>
                        <div style={{ display: this.state.show_valoration ? 'block' : 'none' }}>
                            <span className="size-min">{t('content.modal_hc.result')}</span>
                            <select
                                className="form-control"
                                value="NO_APTO"
                                disabled
                                name="valoration"
                                id="valoration"
                            >
                                <option value="NO_APTO">NO APTO</option>
                            </select>
                        </div>
                    </div>
                    {this.state.show_valoration ?
                        <div style={{ padding: '28px', display: this.state.show_valoration ? 'block' : 'none'}}>
                            <div className="col-xs-12 col-md-5" style={{ padding: "2px 2px 2px 8px" }}>
                                <b><span className="size-min">{t('content.modal_hc.rejection_reasons')}(*)</span></b>
                                {this.state.don_abr_rech.value === "NO" ?
                                    <Typeahead
                                        labelKey={(option) => `${option.name}`}
                                        minLength={0}
                                        name="rejection_reasons_id"
                                        id="rejection_reasons_id"
                                        inputProps={{
                                            required: true,
                                            autoComplete: "off",
                                            name: 'rejection_reason',
                                            id: 'rejection_reason'
                                        }}
                                        options={this.state.rejection_reasons}
                                        onChange={this.handleTypeAheadChange('rejection_reasons_id')}
                                        ref="_handleSearch"
                                        selected={this.state.indiceRejection !== -1 
                                            ? [this.state.rejection_reasons[this.state.indiceRejection]]
                                            : []
                                        }
                                        delay={600}
                                        paginationText="Mostrar mas resultados..." 
                                    />
                                :
                                    <input
                                        className="form-control"
                                        name="rejection_description"
                                        id="rejection_description"
                                        step="0.01"
                                        type="text"
                                        min="0"
                                        onChange={this.handleChangeInput}
                                        value={this.props.state.rejection_description}
                                        required
                                    />
                                }
                            </div>
                            <div className="col-xs-12 col-sm-1">
                                <span className="size-min">Tipo</span>
                                <input
                                    className="form-control"
                                    name="donation_status"
                                    id="donation_status"
                                    disabled
                                    value={this.state.donation_status === "REJECT" 
                                        ? 'PERMANENTE'
                                        : this.state.donation_status === 'DIFERIDO' 
                                            ? 'DIFERIDO' 
                                            : ""
                                    }
                                />
                            </div>
                            {this.state.donation_status === "DIFERIDO" ?
                                <div style={{ padding: "0px" }}>
                                    <div className="col-xs-12 col-md-2" style={{ padding: "0" }}>
                                        <b><span className="size-min" style={{ fontSize: '13px' }}>{t('content.modal_hc.rejection_days')}(*)</span></b>
                                        <input
                                            className="form-control"
                                            name="rejection_days"
                                            id="rejection_days"
                                            step="0.01"
                                            type="number" min="0"
                                            onChange={this.handleChangeInput}
                                            value={this.props.state.rejections_days}
                                            onKeyUp={this.keyUpRejectionDay}
                                            required={this.state.donation_status === "DIFERIDO"}
                                        />
                                    </div>
                                    <div className="col-xs-12 col-md-2" style={{ padding: "0px 8px" }}>
                                        <span className="size-min">{t('content.modal_hc.next_donation')}</span>
                                        <input
                                            className="form-control hour-input"
                                            name="date"
                                            id="date"
                                            type="date"
                                            disabled
                                            value={this.state.date}
                                            required={this.state.donation_status === "DIFERIDO"}
                                        />
                                    </div>
                                </div>
                            : null}
                        </div>
                    : null}
                </div>
            </>
        );
    }
}

export default translate('translations')(RejectionReason);